import { Button } from "@astryxdesign/core/Button";
import { Item } from "@astryxdesign/core/Item";
import { HStack } from "@astryxdesign/core/Stack";
import { Text } from "@astryxdesign/core/Text";
import { Token } from "@astryxdesign/core/Token";
import type { DueEntry } from "../../../shared/money";
import { dueColor, dueLabel, formatDay, formatMoney, formatUah } from "../../lib/money";

interface Props {
  entry: DueEntry;
  onPay: (entry: DueEntry) => void;
  onOpen: (subId: string) => void;
  isPaying: boolean;
}

export function DueRow({ entry, onPay, onOpen, isPaying }: Props) {
  const foreign = entry.currency !== "UAH";
  return (
    <Item
      as="li"
      density="balanced"
      onClick={() => onOpen(entry.subId)}
      label={
        <Text type="body" weight="medium" maxLines={1}>
          {entry.name}
        </Text>
      }
      description={
        <HStack gap={1.5} align="center" wrap="wrap">
          <Token size="sm" color={dueColor(entry.daysLeft)} label={dueLabel(entry.daysLeft)} />
          <Text type="supporting" size="xsm">
            {formatDay(entry.dueDate)}
          </Text>
          {entry.partNumber ? (
            <Text type="supporting" size="xsm">
              part {entry.partNumber}/{entry.parts}
            </Text>
          ) : null}
        </HStack>
      }
      endContent={
        <HStack gap={2} align="center">
          <HStack gap={0} align="end" style={{ flexDirection: "column" }}>
            <Text type="body" weight="medium">
              {formatMoney(entry.amount, entry.currency)}
            </Text>
            {foreign ? (
              <Text type="supporting" size="xsm">
                ≈ {formatUah(entry.amountUah)}
              </Text>
            ) : null}
          </HStack>
          <span onClick={(e) => e.stopPropagation()}>
            <Button
              label="Paid"
              size="sm"
              variant="primary"
              isLoading={isPaying}
              onClick={() => onPay(entry)}
            />
          </span>
        </HStack>
      }
    />
  );
}
